var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ cockpitTitle: true, large: _vm.large, medium: _vm.medium }},[_c('i',{staticClass:"fa fa-square blue",attrs:{"aria-hidden":"true"}}),_vm._v(" ODM "),_c('span',{staticClass:"blue"},[_vm._v("Cockpit")])])}
var staticRenderFns = []

export { render, staticRenderFns }